import { defineMessages } from 'react-intl';

export const linkMessages = defineMessages({
  graphComment: {
    defaultMessage: 'https://www.graphcomment.com/en',
    id: 'TpHX2D',
  },
  graphDebateProduct: {
    defaultMessage: 'https://www.graphcomment.com/en/products/graphdebate/features',
    id: 'JTI/p0',
  },
  cgu: {
    defaultMessage: 'https://www.graphcomment.com/en/conditions',
    id: 'FIjcpF',
  },
});
